var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTooltip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "tooltip") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 14.5C9.72391 14.5 11.3772 13.8152 12.5962 12.5962C13.8152 11.3772 14.5 9.72391 14.5 8C14.5 6.27609 13.8152 4.6228 12.5962 3.4038C11.3772 2.1848 9.72391 1.5 8 1.5C6.27609 1.5 4.6228 2.1848 3.4038 3.4038C2.1848 4.6228 1.5 6.27609 1.5 8C1.5 9.72391 2.1848 11.3772 3.4038 12.5962C4.6228 13.8152 6.27609 14.5 8 14.5ZM16 8C16 10.1217 15.1571 12.1566 13.6569 13.6568C12.1566 15.1571 10.1217 16 8 16C5.8783 16 3.8434 15.1571 2.3431 13.6568C0.8429 12.1566 5.13895e-07 10.1217 6.99382e-07 8C8.84867e-07 5.8783 0.8429 3.8434 2.3431 2.3431C3.8434 0.842898 5.8783 -8.84867e-07 8 -6.99382e-07C10.1217 -5.13895e-07 12.1566 0.842899 13.6569 2.3431C15.1571 3.8434 16 5.8783 16 8ZM7 5C7 4.7348 7.10536 4.4804 7.29289 4.2929C7.48043 4.1054 7.73478 4 8 4C8.26522 4 8.51957 4.1054 8.70711 4.2929C8.89464 4.4804 9 4.7348 9 5C9 5.2652 8.89464 5.5196 8.70711 5.7071C8.51957 5.8946 8.26522 6 8 6C7.73478 6 7.48043 5.8946 7.29289 5.7071C7.10536 5.5196 7 5.2652 7 5ZM7.25 11.25C7.25 11.4489 7.32902 11.6397 7.46967 11.7803C7.61032 11.921 7.80109 12 8 12C8.19891 12 8.38968 11.921 8.53033 11.7803C8.67098 11.6397 8.75 11.4489 8.75 11.25L8.75 7.75C8.75 7.55109 8.67098 7.36032 8.53033 7.21967C8.38968 7.07902 8.19891 7 8 7C7.80109 7 7.61032 7.07902 7.46967 7.21967C7.32902 7.36032 7.25 7.55109 7.25 7.75L7.25 11.25Z",
    fill: "black",
    fillOpacity: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTooltip);
export default __webpack_public_path__ + "static/media/tooltip.6b413b58828bb4d9680310e967b4cfc9.svg";
export { ForwardRef as ReactComponent };